export default "__VITE_ASSET__CWjjPJf6__"